import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import SchoolIcon from "@mui/icons-material/School";
import "./SkillsTreePreviewComponent.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SkillTreePreviewComponent = ({ techFieldName, sub_id }) => {
  const getCertificateSlug = (subId) => `${subId}-development`;

  const history = useHistory();
  return (
    <div className="skilltreepreview-container">
      <div className="skilltreepreview-content">
        <h1 className="skilltreepreview-title">You're on Track</h1>

        <div className="skilltreepreview-progress-wrapper">
          {/* Progress Line */}
          <div className="skilltreepreview-progress-line">
            <div className="skilltreepreview-progress-fill"></div>
          </div>

          {/* Step 1: Badge Earned */}
          <div className="skilltreepreview-step skilltreepreview-step-completed">
            <div className="skilltreepreview-icon-wrapper skilltreepreview-icon-completed">
              <CheckCircleIcon className="skilltreepreview-icon" />
            </div>
            <div className="skilltreepreview-step-label">
              <div className="skilltreepreview-step-title">Badge</div>
              <div className="skilltreepreview-step-subtitle">Earned</div>
            </div>
          </div>

          {/* Step 2: Certification */}
          <div className="skilltreepreview-step skilltreepreview-step-current">
            <div className="skilltreepreview-icon-wrapper skilltreepreview-icon-current skilltreepreview-icon-pulse">
              <CardMembershipIcon className="skilltreepreview-icon" />
            </div>
            <div className="skilltreepreview-step-label">
              <div className="skilltreepreview-step-title">Certification</div>
            </div>
          </div>

          {/* Step 3: Pro Developer */}
          <div className="skilltreepreview-step skilltreepreview-step-locked">
            <div className="skilltreepreview-icon-wrapper skilltreepreview-icon-locked">
              <SchoolIcon className="skilltreepreview-icon" />
            </div>
            <div className="skilltreepreview-step-label">
              <div className="skilltreepreview-step-title">Pro</div>
              <div className="skilltreepreview-step-subtitle">Developer</div>
            </div>
          </div>
        </div>

        {/* Description and CTA */}
        <div className="skilltreepreview-description">
          <p className="skilltreepreview-text">
            You've mastered the fundamentals.
          </p>
          <p className="skilltreepreview-text">
            Earn your{" "}
            <span className="skilltreepreview-text-techfield">
              {" "}
              {techFieldName}
            </span>{" "}
            Certification
          </p>
          <p className="skilltreepreview-text">to stand out to recruiters.</p>
        </div>

        <button
          onClick={() =>
            history.push(`/certificates/list/${getCertificateSlug(sub_id)}`)
          }
          className="skilltreepreview-cta-button"
        >
          Unlock Your Certificate →
        </button>

        <p className="skilltreepreview-footer">
          Verified certificate. Shareable on LinkedIn. Recognized by tech
          recruiters.
        </p>
      </div>
    </div>
  );
};

export default SkillTreePreviewComponent;
